export default "__VITE_ASSET__697b0e04__"